import styled from 'styled-components';

import { Box, Text, Tag } from '@gympass/yoga';
import Instagram from 'icons/instagram.svg';

import {
  CareProviderAvatar,
  CareProviderAvatarText,
  SocialContainer,
  SocialUsername,
} from 'pages/CareProviderInfo/styles';

export const Container = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
})`
  padding: ${({ theme }) => theme.yoga.spacing.xlarge}px
    ${({ theme }) => theme.yoga.spacing.medium}px
    ${({ theme }) => theme.yoga.spacing.zero}px;
`;

export const ModalHeaderContainer = styled(Box).attrs({
  display: 'flex',
  alignItems: 'center',
})`
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxlarge}px;
`;

export const StyledCareProviderAvatar = styled(CareProviderAvatar)`
  margin-right: ${({ theme }) => theme.yoga.spacing.large}px;
  width: ${({ theme }) => theme.yoga.sizes.avatarpublishedProfileWidth}px;
  height: ${({ theme }) => theme.yoga.sizes.avatarpublishedProfileHeight}px;
  border: none;
`;

export const StyledCareProviderAvatarText = styled(CareProviderAvatarText)``;

export const ModalHeaderInfoContainer = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
})``;

export const CareProviderFullName = styled(Text.H5)`
  color: ${({ theme }) => theme.yoga.colors.stamina};
`;

export const CareProviderProfessionalInformation = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.deep};
`;

export const StyledSocialContainer = styled(SocialContainer)`
  margin-top: ${({ theme }) => theme.yoga.spacing.zero};
`;

export const StyledSocialUsername = styled(SocialUsername)`
  color: ${({ theme }) => theme.yoga.colors.primary};
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
`;

export const StyledInstagram = styled(Instagram)`
  g {
    fill: ${({ theme }) => theme.yoga.colors.primary};
  }
`;

export const CareProviderVideo = styled.iframe.attrs({
  frameBorder: 0,
})`
  width: ${({ theme }) => theme.yoga.sizes.iframeCPVideoWidth}px;
  height: ${({ theme }) => theme.yoga.sizes.iframeCPVideoHeight}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const SectionsContainer = styled(Box).attrs({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'flex-start',
})`
  width: ${({ theme }) =>
    theme.yoga.sizes.sectionPublishedProfileContainerWidth}px;
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xlarge}px;
`;

export const Section = styled(Box).attrs({})`
  & + & {
    margin-top: ${({ theme }) => theme.yoga.spacing.large}px;
  }
`;

export const SectionTitle = styled(Text.Small)`
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  margin-bottom: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
`;

export const SectionText = styled(Text.Small)`
  color: ${({ theme }) => theme.yoga.colors.deep};
`;

export const AreasContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledTag = styled(Tag)`
  color: ${({ theme }) => theme.yoga.colors.stamina};
  border-color: ${({ theme }) => theme.yoga.colors.stamina};

  & + & {
    margin-left: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  }
`;
